import { Table, Button } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { policyType } from '../../../texts/policy'
import { policies } from '@services/api'
import ClientsPopup from '@components/Popup/ClientsPopup'
@inject((store: any) => {
    const { clientsStore, popupStore } = store
    return { clientsStore, popupStore }
})
@observer
export default class extends Component<any, any> {
    state = { pols: [] }
    componentDidMount() {
        this.getInsuranceCases()
    }
    getInsuranceCases = () => {
        policies
            .getNullPolAtCases()
            .then(res => this.setState({ pols: res.data }))
            .catch(err => console.log({ err }))
    }
    handleClientList = async InsuranceCase => {
        const {
            clientsStore: { clientsByInsuranceCase, changePage },
            popupStore: { togglePopup }
        } = this.props
        await changePage(1)
        await clientsByInsuranceCase({ ...InsuranceCase })
        togglePopup('clientsPopup', { ...InsuranceCase })
    }
    render() {
        let { pols } = this.state
        let columns = [
            {
                title: 'רשימת לקוחות',
                key: 'client_list',
                width: 200,
                align: 'right',
                render: (_, record) => <Button onClick={() => this.handleClientList(record)}>רשימת לקוחות</Button>
            },
            {
                title: 'חברה',
                width: 250,
                key: 'company',
                align: 'right',
                render: (_, record) => (
                    <span style={{ color: !record.company_id ? 'red' : undefined }}>{record.company}</span>
                )
            },
            {
                title: 'קטגוריה ראשית',
                width: 200,
                key: 'main_cat',
                align: 'right',
                render: (_, record) => <span>{record.mainCat}</span>
            },
            {
                title: 'קטגוריה משנית',
                key: 'sub_cat',
                width: 250,
                align: 'right',
                render: (_, record) => (
                    <span style={{ color: !record.subCat ? 'red' : undefined }}>
                        {record.subCat || record.sub_category}
                    </span>
                )
            },
            {
                title: 'סוג',
                key: 'type',
                width: 200,
                align: 'right',
                render: (_, record) => <span key={record.policy_type}>{policyType[record.policy_type]}</span>
            },
            {
                title: 'סיבת כשל',
                key: 'failure',
                align: 'right',
                render: (_, record) => {
                    let failReason = <span>קיימים מקרים בהם שילוב זה לא שוייך לפוליסה</span>
                    if (!record.subCat)
                        failReason = (
                            <span>
                                לא נמצאה תת קטגוריה בשם <strong>{record.sub_category}</strong>
                            </span>
                        )
                    if (!record.company_id)
                        failReason = (
                            <span>
                                לא נמצאה חברה בשם <strong>{record.company}</strong>
                            </span>
                        )
                    return failReason
                }
            }
        ]

        return pols.length ? (
            <>
                <Table
                    rowKey={record =>
                        `${record.company}_${record.sub_category}_${record.main_category}_${record.policy_type}`
                    }
                    dataSource={pols}
                    columns={columns}
                    pagination={{
                        pageSize: 10
                    }}
                />
                <ClientsPopup popupClosed={this.getInsuranceCases} />
            </>
        ) : (
            ''
        )
    }
}
